/* eslint-env node */

const path = require(`path`);

const IRON_APPS_DIR = `iron/apps`;
const IRON_APPS_INFO = require(`./apps-info.json`);
const IRON_APPS = Object.keys(IRON_APPS_INFO);
const BASE_APPS = [`common`, `design-system`];
const ALL_APPS = [...BASE_APPS, ...IRON_APPS];

function appDir(app) {
  return BASE_APPS.includes(app) ? path.join(`iron`, app) : path.join(IRON_APPS_DIR, app);
}

module.exports = {IRON_APPS_INFO, IRON_APPS, IRON_APPS_DIR, ALL_APPS, appDir};
